import React, { useEffect } from 'react'
import { AuthenticatedHeader } from '../../../components/Header/AuthenticatedHeader'
import Footer from '../../../components/Footer/Footer'
import gridClasses from '../../../styles/grid.module.css'
import classes from './CancelSubscription.module.css'
import classNames from 'classnames'
import { CourseCard } from '../../../components/Cards/GeneralCard/Card'
import { getImageURL } from '../../../util/functions'
import coursePlaceholder from '../../../assets/images/course-placeholder.svg'
import { Button } from '../../../components/Button/Button'
import { useDispatch, useSelector } from 'react-redux'
import { cancelSubscriptionSelectors } from './cancelSubscriptionSlice'
import CardLoader from '../../../components/loaders/CardLoader'
import { cancelSubscription, getFreeCourses } from './cancelSubscriptionApi'
import { userSelectors } from '../../../redux/userSlice'
import notification from '../../../components/Notification/notification'
import { useHistory } from 'react-router'

const CancelSubscription = () => {
    const dispatch = useDispatch()
    const history = useHistory()

    const user = useSelector(userSelectors.userDetails)

    const isFetching = useSelector(cancelSubscriptionSelectors.isFetching)
    const hasError = useSelector(cancelSubscriptionSelectors.hasError)
    const errorMessage = useSelector(cancelSubscriptionSelectors.errorMessage)

    const freeCourses = useSelector(cancelSubscriptionSelectors.freeCourses)

    const cancelSuccess = useSelector(cancelSubscriptionSelectors.cancelSuccess)

    const onCancel = () => {
        notification.loading({
            title: 'Cancelling subscription',
        })
        dispatch(cancelSubscription(user.email))
    }

    useEffect(() => {
        if (cancelSuccess) {
            notification.destroy()
            notification.success({
                title: 'Subscription cancelled successfully',
            })
            history.push('/app/account/subscription')
        }

        if (hasError.cancelSubscription) {
            notification.destroy()
            notification.failure({
                title: 'Error cancelling subscription',
                description: errorMessage.cancelSubscription,
            })
        }
    }, [cancelSuccess, hasError.cancelSubscription])

    useEffect(() => {
        dispatch(getFreeCourses(user.email))
    }, [])

    useEffect(() => {
        if (hasError.freeCourses) {
            notification.failure({
                title: 'Error fetching your free courses',
                description: errorMessage.freeCourses,
            })
        }
    }, [hasError.freeCourses])

    return (
        <>
            <AuthenticatedHeader />
            <main className={classes.main}>
                <h3
                    className={classNames(
                        classes.header,
                        gridClasses.container
                    )}
                >
                    If you cancel your subscription, you will lose access to
                    your free courses.
                </h3>
                <section className={classes.mainContent}>
                    <div
                        className={classNames(
                            gridClasses.container,
                            gridClasses.containerWhite
                        )}
                    >
                        <h5 className={classes.mainContentHeader}>
                            You have <b>{freeCourses.length}</b> free courses
                        </h5>
                        <div className={classes.mainContentGrid}>
                            {isFetching.freeCourses ? (
                                <>
                                    <CardLoader />
                                    <CardLoader />
                                    <CardLoader />
                                </>
                            ) : (
                                freeCourses.map(
                                    ({
                                        title,
                                        thumbnail,
                                        catName,
                                        price,
                                        enrolled,
                                        freeonsubscription,
                                        showstudentcount,
                                        coursecode,
                                    }) => (
                                        <CourseCard
                                            showStudentCount={
                                                String(showstudentcount) === '1'
                                            }
                                            premium={
                                                String(freeonsubscription) ===
                                                '0'
                                            }
                                            attendees={enrolled}
                                            coursecode={coursecode}
                                            title={title}
                                            category={catName}
                                            price={price}
                                            url={
                                                thumbnail
                                                    ? getImageURL(thumbnail)
                                                    : coursePlaceholder
                                            }
                                            className={
                                                classes.mainContentGridItem
                                            }
                                        />
                                    )
                                )
                            )}
                        </div>
                    </div>
                </section>
                <div
                    className={classNames(
                        classes.bottom,
                        gridClasses.container
                    )}
                >
                    <h5 className={classes.bottomHeader}>
                        {/*TODO: This text literally makes no sense*/}
                        If you cancel, you'll lose your premium downloads and
                        commercial licenses will not be active anymore. Don't
                        forget, Premium Subscription give you access to all
                        Premium downloads with commercial licenses.
                    </h5>
                    <div className={classes.bottomButtons}>
                        <Button bold to={'/app/account/subscription'}>
                            Yes, keep my privileges
                        </Button>
                        <Button
                            className={classes.bottomCancelButton}
                            onClick={onCancel}
                        >
                            No thanks, continue cancelling
                        </Button>
                    </div>
                </div>
            </main>
            <Footer />
        </>
    )
}

export default CancelSubscription
